import React from 'react';

import './details-asset.styles.scss';

export const Image = ({image, title}) => (
    <div className="details-asset">
        <div className="container">
            <img src={image} alt={title}/>
        </div>
    </div>
)